import { isPS, replaceLocationHost } from '@/utils';
import { z } from 'zod';

export const BulkExportPdfModel = z
  .object({
    url: z.string(),
    fileName: z.string(),
  })
  .transform((v) => {
    return {
      ...v,
      // 見える化サイトの場合、proxyが存在しないため、URLのホスト名を置き換えない
      url: replaceLocationHost(v.url, !isPS()),
    };
  });
